module.exports = __webpack_public_path__ + "img/about-banner.e94a565e.jpg";